import axios from "../axios";
import crInstance from "../crAxios";

const getInstance = (isCR) => (isCR ? crInstance : axios);
const crBaseURL = process.env.REACT_APP_CR_API_URL;

export const postData = async ({
  endpoint,
  data,
  params,
  token,
  isCR = false,
}) => {
  try {
    const response = await getInstance(isCR).post(endpoint, data, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return { data: response.data, isLoading: false };
  } catch (error) {
    console.error("Error posting data:", error);
    throw { error, isLoading: false };
  }
};

export const postFormData = async ({
  endpoint,
  data,
  params,
  token,
  isCR = false,
}) => {
  try {
    const response = await getInstance(isCR).post(endpoint, data, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return { data: response.data, isLoading: false };
  } catch (error) {
    console.error("Error posting data:", error);
    throw { error, isLoading: false };
  }
};

export const deleteData = async ({ endpoint, params, token, isCR = false }) => {
  try {
    const response = await getInstance(isCR).delete(endpoint, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return { data: response.data, isLoading: false };
  } catch (error) {
    console.error("Error deleting data:", error);
    throw { error, isLoading: false };
  }
};

// -------------------------------------------------------------------------------------

export const patchData = async ({
  endpoint,
  data,
  params,
  token,
  isCR = false,
}) => {
  try {
    const response = await getInstance(isCR).patch(endpoint, data, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error patching data:", error);
    throw error;
  }
};

export const putData = async ({
  endpoint,
  data,
  params,
  token,
  isCR = false,
}) => {
  try {
    const response = await getInstance(isCR).put(endpoint, data, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in putting data:", error);
    throw error;
  }
};

export const patchFormData = async ({
  endpoint,
  data,
  params,
  token,
  isCR = false,
}) => {
  try {
    const response = await getInstance(isCR).patch(endpoint, data, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error patching data:", error);
    throw error;
  }
};

export const getData = async ({ endpoint, params, token, isCR = false }) => {
  try {
    const response = await getInstance(isCR).get(endpoint, {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting data:", error);
    throw error;
  }
};
export const downloadReport = async ({
  endpoint,
  token,
  fileName,
  params,
  isCR = false,
  data = {},
}) => {
  try {
    const sendurl = `${crBaseURL}${endpoint}`;

    const response = await getInstance(isCR).post(sendurl, data, {
      params: params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "blob", // ✅ already gives Blob
    });

    // ✅ response.data is already a Blob
    const blob = response.data;

    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.xlsx`; // optional: ensure extension
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Error downloading report:", error);
    return false;
  }
};
